import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export type InfoIconStrokeProps = {
  size?: number
  fillColor?: string
  testID?: string
}

export const InfoIconStroke: FunctionComponent<InfoIconStrokeProps> = ({ size = 24, fillColor, testID }) => {
  const { colors } = useTheme()

  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' testID={testID}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12ZM3.5 12C3.5 7.313 7.313 3.5 12 3.5C16.687 3.5 20.5 7.313 20.5 12C20.5 16.687 16.687 20.5 12 20.5C7.313 20.5 3.5 16.687 3.5 12Z'
        fill={fillColor || colors.iconActive}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 10.25C12.4142 10.25 12.75 10.5858 12.75 11V15.5C12.75 15.9142 12.4142 16.25 12 16.25C11.5858 16.25 11.25 15.9142 11.25 15.5V11C11.25 10.5858 11.5858 10.25 12 10.25Z'
        fill={fillColor || colors.iconActive}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.25 8.5C11.25 8.08579 11.5858 7.75 12 7.75H12.0067C12.4209 7.75 12.7567 8.08579 12.7567 8.5C12.7567 8.91421 12.4209 9.25 12.0067 9.25H12C11.5858 9.25 11.25 8.91421 11.25 8.5Z'
        fill={fillColor || colors.iconActive}
      />
    </Svg>
  )
}
